import { getSession, setSession } from '@/utils'
import { showConfirmDialog } from 'vant'
import { createRouter, createWebHistory } from 'vue-router'

const Index = () => import('@/pages/index/Index.vue')
const Tasks = () => import('@/pages/tasks/Tasks.vue')
const TaskDetail = () => import('@/pages/tasks/TaskDetail.vue')
const CheckDetail = () => import('@/pages/perform/CheckDetail.vue')
const Report = () => import('@/pages/tasks/Report.vue')
const CheckMap = () => import('@/pages/tasks/Map.vue')
const Illegal = () => import('@/pages/index/Illegal.vue')
const TaskSelect = () => import('@/pages/tasksCreate/TaskSelect.vue')
const TaskCreate = () => import('@/pages/tasksCreate/TaskCreate.vue')
const SearchTask = () => import('@/pages/tasks/SearchTask.vue')
const FirstInputInfo = () => import('@/pages/index/FirstInputInfo.vue')
const IsExpire = () => import('@/pages/index/IsExpire.vue')
const Summary = () => import('@/pages/tasks/Summary.vue')
const routes = [
	{
		path: '/',
		name: '/',
		redirect: '/index',
	},
	{
		path: '/illegal',
		name: 'illegal',
		component: Illegal,
	},
	{
		path: '/first_input_info',
		name: 'first_input_info',
		component: FirstInputInfo,
	},
	{
		path: '/is_expire',
		name: 'is_expire',
		component: IsExpire,
	},
	{
		path: '/index',
		name: 'index',
		component: Index,
		meta: {
			title: '光印巡检',
		},
	},
	{
		path: '/tasks',
		name: 'tasks',
		component: Tasks,
	},
	{
		path: '/searchTask',
		name: 'searchTask',
		component: SearchTask,
		meta: {
			title: '全部任务',
		},
	},
	{
		path: '/taskDetail',
		name: 'taskDetail',
		component: TaskDetail,
	},
	{
		path: '/checkDetail',
		name: 'checkDetail',
		component: CheckDetail,
	},
	{
		path: '/report',
		name: 'report',
		component: Report,
		meta: {
			title: '巡检报告',
		},
	},
	{
		path: '/checkMap',
		name: 'checkMap',
		component: CheckMap,
		meta: {
			title: '巡检作战地图',
		},
	},
	{
		path: '/taskSelect',
		name: 'taskSelect',
		component: TaskSelect,
	},
	{
		path: '/taskCreate',
		name: 'taskCreate',
		component: TaskCreate,
	},
	{
		path: '/summary',
		name: 'summary',
		component: Summary,
		meta: {
			title: '巡检总结',
		},
	},
]

const router = createRouter({
	history: createWebHistory(),
	routes, 
})

router

router.afterEach((to, from, failure) => {
	setSession('last_path', from.path)
	// 存储路由历史
	let history = getSession('history') || []
	history.push(to.path)
	setSession('history', history)
	if (to.meta.title) {
		document.title = to.meta.title
	} else if (to.query.title) {
		document.title = to.query.title
	} else {
		document.title = '光印巡检'
	}
})

router.onError((err) => {
	console.info(err)
	showConfirmDialog({
		message: '检测到当前版本有更新，点击刷新即可正常使用',
		confirmButtonText: '刷新',
		showCancelButton: false,
	}).then(() => {
		location.reload()
	})
})

export default router
